<template>
  <div>
    <div v-if="success"  tabindex="-1" role="dialog" @touchmove.prevent  aria-label="" class="el-message-box__wrapper" style="z-index: 2018;background: rgba(0,0,0,0.45);">
      <div  class="el-message-box custom-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title"><!---->
            <span>{{Tip}}</span>
          </div><!---->
        </div>
        <div class="el-message-box__content" style="width: 420px;">
          <div class="el-message-box__message">
            <div>
              <div class="marBot20">
                <i :class="icon"  style="font-size:44px;color:#1aad19"></i>
              </div>
              <div class="font12 colBlack marBot20" style="padding: 0 30px">
                  {{title}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    Tip: { type: String }, //标题
    success: { type: Boolean }, //是否弹出
    title: { type: String }, //弹出文字
    icon: { type: String }, //icon类名
  },
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/userCenter/public/alertSuccess.vue